import { defineStore } from 'pinia';
import useSettingsGlobals from '@/composables/useSettingsGlobals';
import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals'

const { $UI_DEFAULT_THEME } = useSettingsGlobals();
const {
  $REGIONAL_NAVIGATION,
  $CUSTOMIZE_MAP_BUTTON_DEFAULT,
  $MESONET_FILTER_BUTTON,
  $UI_STORAGE_NAME
} = useMapConfigurationGlobals()

const storeName = $UI_STORAGE_NAME || 'mapUIStore'

export let useMapUIStore = defineStore(storeName, {
  state: () => ({
    defaultTheme: $UI_DEFAULT_THEME,
    mapAutoRefresh: 0,
    mapBackground: 'High Contrast',
    mapBackgroundTheme: 'system',
    pinnedMaps: [],
    showCustomizeMapButton: $CUSTOMIZE_MAP_BUTTON_DEFAULT,
    showDrawingTools: false,
    showLegend: true,
    showPinnedMapBar: true,
    showRegionalNavigation: $REGIONAL_NAVIGATION,
    showSpotFilterButton: $MESONET_FILTER_BUTTON,
    showZoomControl: true,
    theme: ''
  }),
  actions: {
    updateTheme(systemThemeIsDark = null) {
      const body = document.documentElement;
      let theme = this.theme === '' ? this.defaultTheme : this.theme;

      if (this.theme === 'system') {
        theme = systemThemeIsDark ? 'dark' : 'light';
      }

      body.dataset.theme = theme;
    },
    updateMapBackgroundTheme(systemThemeIsDark = null) {
      const body = document.documentElement;
      let theme = this.mapBackgroundTheme || 'light';

      if (this.mapBackgroundTheme === 'system') {
        theme = systemThemeIsDark ? 'dark' : 'light';
      }

      body.dataset.mapBackgroundTheme = theme;
    },
    updateMapBackground(background) {
      this.mapBackground = background;
    },
    updateThemes(systemThemeIsDark = null) {
      this.updateTheme(systemThemeIsDark);
      this.updateMapBackgroundTheme(systemThemeIsDark);
    },
    toggleLegend() {
      const mapContainer = document.querySelector('.map-container')
      mapContainer.style.setProperty('--legend-height', this.showLegend ? '50px' : '0')
    },
    toggleDrawingTools() {
      this.showDrawingTools = !this.showDrawingTools;
    },
    isStormTrackUI(isStormTrack) {
      const body = document.documentElement
      body.dataset.uiStormTrack = isStormTrack ? true : false
    },
    hasRegionalNavigation(hasRegionalNav) {
      const body = document.documentElement
      body.dataset.uiRegionalNav = hasRegionalNav ? true : false
    },
    addPinnedMap(mapId) {
      // TODO: Moved pinned maps to use store
      if (this.pinnedMaps.indexOf(mapId) > -1) return

      if (this.pinnedMaps.length >= 5) {
        if (jwc) {
          jwc.toaster.toast({
            type: 'warning',
            content: 'Only 5 maps can be pinned at once.'
          })
        }

        return
      }

      this.pinnedMaps.push(mapId)
    },
    removePinnedMap(mapId) {
      const index = this.pinnedMaps.indexOf(mapId)
      if (index === -1) return

      this.pinnedMaps.splice(index, 1)
    }
  },
  persist: true
})